import { render } from "./App.vue?vue&type=template&id=96f32cfc&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=96f32cfc&scoped=true&lang=css"

import exportComponent from "C:\\Users\\katsuta\\Documents\\AiGlies\\node\\project\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96f32cfc"]])

export default __exports__